export default __webpack_public_path__ + "static/media/set8.a85e54e2.jpeg";